// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2I7xZ","label":"Section_label__8BkfO","contentWrap":"Section_contentWrap__2wc1d","footer":"Section_footer__1Gb3w","footerInner":"Section_footerInner__1AiMX"};